const PersonalDetails = ({ formData, setFormData, errors }) => {
   return (
      <>
         <h1>Personal Details</h1>
         <input
            type="text"
            placeholder="Enter Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
         />
         {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}

         <input
            type="email"
            placeholder="Email"
            style={{ marginTop: ".5rem" }}
            value={formData.email}
            onChange={(e) =>
               setFormData({ ...formData, email: e.target.value })
            }
         />
         {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
      </>
   );
};

export default PersonalDetails;
